import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UsersService } from '../services/users.service';

/**
 * Utilisé pour intercepter les requêtes HTTP afin de gérer les reponses d'erreur.
 */
@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
    constructor(private usersService: UsersService, private router: Router, private toastr: ToastrService, private translate: TranslateService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (sessionStorage.getItem('SessionId')) {
            const authReq = req.clone({
                headers: req.headers.append('SessionId', sessionStorage.getItem('SessionId')),
            });
            return next.handle(authReq).pipe(catchError((error: unknown) => this.handleError(error as HttpErrorResponse, req)));
        } else {
            return next.handle(req).pipe(catchError((error: unknown) => this.handleError(error as HttpErrorResponse, req)));
        }
    }

    /**
     * Gère une réponse en erreur.
     */
    public handleError(error: HttpErrorResponse, req: HttpRequest<any>) {
        if (error.status === 401) {
            this.usersService.removeCurrentUser();
            console.log(this.translate);
            this.translate.get('Errors.AccessDenied').subscribe((message: string) => {
                this.toastr.error(message);
                this.router.navigate(['/login']);
            });
        } else if (error.status === 402) {
            this.usersService.removeCurrentUser();
            this.translate.get('Errors.SessionExpired').subscribe((message: string) => {
                this.toastr.info(message);
                this.router.navigate(['/login']);
            });
        } else if (req.headers.get('global-notification')?.toLowerCase() === 'false') {
            // Vérifie si il ne faut pas utiliser les notifications globales
            throwError(() => error);
        } else if (error.status === 403) {
            if (!error.url.includes('api/token')) {
                this.translate.get('Errors.NotRights').subscribe((message: string) => {
                    this.toastr.warning(message);
                });
            } else {
                throwError(error);
            }
        } else if (error.status === 409) {
            this.translate.get('Errors.Conflict').subscribe((message: string) => {
                this.toastr.warning(message);
            });
        } else if (error.status === 423) {
            this.translate.get('Errors.AccountLocked').subscribe((message: string) => {
                this.toastr.warning(message, '', { enableHtml: true });
            });
        } else if (error.status === 426) {
            this.translate.get('Errors.PasswordExpired').subscribe((message: string) => {
                this.toastr.warning(message, '', { enableHtml: true });
            });
        } else if (error.status === 500) {
            this.translate.get('Errors.InternalServerError').subscribe((message: string) => {
                this.toastr.warning(message);
            });
        } else if (error.status === 503) {
            this.translate.get('Errors.ServiceUnavailable').subscribe((message: string) => {
                this.toastr.warning(message);
            });
        }

        console.log('Custom error handling: [' + error.status + '] ' + error.message);

        return throwError(error);
    }
}
